// extracted by mini-css-extract-plugin
module.exports = {"noBr":"StorySectionTitle-module--noBr--3vA2q","title":"StorySectionTitle-module--title--1VL5m","subtitle":"StorySectionTitle-module--subtitle--3Hmi1"};